import { List, ListItem } from '@mui/material';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { HEADER_LINK_STYLE } from '../../../constants/layout';
import { LinkOrMenu } from '../../../utils/layout';
import { Button } from '../../atoms/Button';
import { IconChevron } from '../../icons/IconChevron';

export type HeaderLinksMobileProps = {
  links: LinkOrMenu[];
  onClick: () => void;
};

export const HeaderLinksMobile = ({ links, onClick }: HeaderLinksMobileProps) => {
  const [activeItem, setActiveItem] = useState<number | undefined>();
  const location = useLocation();

  return (
    <List
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        rowGap: '2.5rem'
      }}
    >
      {links.map(({ label, to, href, subLinks }, index) => {
        const isOpen = activeItem === index;
        const hasSubLinks = subLinks && subLinks.length !== 0;
        const isCurrentPage: boolean = Boolean(to && location.pathname === to);
        const isCurrentSection: boolean =
          isCurrentPage || Boolean(subLinks?.some((subLink) => location.pathname === subLink.to));
        return (
          <ListItem
            key={label}
            sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', p: 0 }}
            {...(isCurrentSection ? { 'aria-current': true } : {})}
          >
            <Button
              to={to}
              href={href}
              disableRipple
              onClick={() => {
                // Reset active item
                setActiveItem(undefined);

                // If submenu and not active, show sublinks
                if (hasSubLinks && !isOpen) {
                  setActiveItem(index);
                }
                // If link, close menu
                else if (!hasSubLinks) {
                  onClick();
                }
              }}
              endIcon={subLinks && <IconChevron orientation={isOpen ? 'top' : 'bottom'} />}
              sx={{ ...HEADER_LINK_STYLE({ isActive: isCurrentPage }) }}
              {...(isCurrentPage ? { 'aria-current': 'page' } : {})}
            >
              {label}
            </Button>
            {isOpen && (
              <List
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  rowGap: '1.75rem',
                  mt: '1.75rem',
                  pl: '1rem'
                }}
              >
                {subLinks?.map((subLink) => {
                  const isSubLinkCurrentPage = Boolean(subLink.to && location.pathname === subLink.to);

                  return (
                    <ListItem
                      key={subLink.label}
                      sx={{ p: 0 }}
                      {...(isSubLinkCurrentPage ? { 'aria-current': true } : {})}
                    >
                      <Button
                        to={subLink.to}
                        href={subLink.href}
                        onClick={onClick}
                        disableRipple
                        sx={{ ...HEADER_LINK_STYLE({ isActive: isSubLinkCurrentPage }), color: '#000' }}
                        {...(isSubLinkCurrentPage ? { 'aria-current': 'page' } : {})}
                      >
                        {subLink.label}
                      </Button>
                    </ListItem>
                  );
                })}
              </List>
            )}
          </ListItem>
        );
      })}
    </List>
  );
};
